<template lang="pug">
v-container.pa-4
  v-card(outlined)
    v-card-title.headline
      | Plantillas de Personalización
      v-spacer
      v-btn(
        color="primary"
        @click="openDialog({})"
      )
        v-icon(left) mdi-plus
        | Nueva Plantilla
      
    v-card-text
      v-data-table(
        :headers="headers"
        :items="templates"
        :items-per-page="10"
        :loading="loading"
        item-key="_id"
      )
        template(v-slot:item.active="{ item }")
          v-chip(
            :color="item.active ? 'success' : 'error'"
            small
          ) {{ item.active ? 'Activo' : 'Inactivo' }}
        
        template(v-slot:item.actions="{ item }")
          v-btn(
            icon
            small
            @click="openDialog(item)"
          )
            v-icon mdi-pencil
          v-btn(
            icon
            small
            @click="confirmDelete(item)"
          )
            v-icon mdi-delete
  
  // Dialog para crear/editar plantillas
  v-dialog(
    v-model="dialog"
    max-width="800px"
    persistent
  )
    v-card
      v-card-title
        span.headline {{ isEditing ? 'Editar Plantilla' : 'Nueva Plantilla' }}
      
      v-card-text
        v-form(
          ref="form"
          v-model="valid"
        )
          v-row
            v-col(cols="12")
              v-text-field(
                v-model="editedItem.name"
                label="Nombre de la Plantilla"
                :rules="[rules.required]"
                required
              )
            
            v-col(cols="12")
              v-textarea(
                v-model="editedItem.description"
                label="Descripción"
                rows="2"
              )
            
            v-col(cols="12")
              v-switch(
                v-model="editedItem.active"
                label="Activa"
                color="success"
                hide-details
                inset
              )
            
            v-col(cols="12")
              v-card(outlined)
                v-card-title.subtitle-1 Grupos de Selección
                v-card-text
                  div(v-if="!editedItem.selectionGroups || editedItem.selectionGroups.length === 0")
                    v-alert(
                      type="info"
                      text
                      dense
                    ) No hay grupos de selección asignados a esta plantilla.
                  
                  template(v-else)
                    v-expansion-panels(v-model="expandedPanels" multiple)
                      v-expansion-panel(
                        v-for="(item, index) in editedItem.selectionGroups"
                        :key="index"
                      )
                        v-expansion-panel-header
                          div(class="d-flex align-center")
                            span {{ getGroupName(item.group) }}
                            v-spacer
                            v-chip(
                              color="primary"
                              small
                              class="mx-2"
                            ) {{ item.required ? 'Requerido' : 'Opcional' }}
                        
                        v-expansion-panel-content
                          v-row
                            v-col(cols="12" sm="6")
                              v-switch(
                                v-model="item.required"
                                label="Requerido"
                                color="primary"
                                hide-details
                                inset
                              )
                            
                            v-col(cols="12" sm="6")
                              v-text-field(
                                v-model.number="item.maxSelections"
                                label="Máx. Selecciones"
                                type="number"
                                min="0"
                                hint="0 = Sin límite"
                                persistent-hint
                              )
                            
                            v-col(cols="12" sm="6")
                              v-text-field(
                                v-model.number="item.minSelections"
                                label="Mín. Selecciones"
                                type="number"
                                min="0"
                              )
                          
                          v-btn(
                            color="error"
                            text
                            small
                            @click="removeGroup(index)"
                          )
                            v-icon(left small) mdi-delete
                            | Quitar Grupo
                
                v-card-actions
                  v-btn(
                    color="primary"
                    text
                    @click="selectGroupDialog = true"
                  )
                    v-icon(left) mdi-plus
                    | Agregar Grupo
      
      v-card-actions
        v-spacer
        v-btn(
          color="grey darken-1"
          text
          @click="closeDialog"
        ) Cancelar
        v-btn(
          color="primary"
          :disabled="!valid"
          @click="save"
        ) Guardar
  
  // Dialog para seleccionar grupos
  v-dialog(
    v-model="selectGroupDialog"
    max-width="500px"
  )
    v-card
      v-card-title Seleccionar Grupo
      
      v-card-text
        v-autocomplete(
          v-model="selectedGroup"
          :items="availableGroups"
          item-text="name"
          item-value="_id"
          label="Grupo de Selección"
          return-object
          :rules="[rules.required]"
        )
        
        v-row
          v-col(cols="12" sm="6")
            v-switch(
              v-model="newGroupItem.required"
              label="Requerido"
              color="primary"
              inset
            )
          
          v-col(cols="12" sm="6")
            v-text-field(
              v-model.number="newGroupItem.maxSelections"
              label="Máx. Selecciones"
              type="number"
              min="0"
              hint="0 = Sin límite"
              persistent-hint
            )
          
          v-col(cols="12" sm="6")
            v-text-field(
              v-model.number="newGroupItem.minSelections"
              label="Mín. Selecciones"
              type="number"
              min="0"
            )
      
      v-card-actions
        v-spacer
        v-btn(
          text
          @click="selectGroupDialog = false"
        ) Cancelar
        v-btn(
          color="primary"
          :disabled="!selectedGroup"
          @click="addSelectedGroup"
        ) Agregar
  
  // Dialog de confirmación para eliminar
  v-dialog(
    v-model="confirmDialog"
    max-width="400px"
  )
    v-card
      v-card-title.error--text ¿Eliminar plantilla?
      v-card-text ¿Estás seguro de que deseas eliminar la plantilla "{{ itemToDelete.name }}"? Esta acción no se puede deshacer.
      v-card-actions
        v-spacer
        v-btn(
          text
          @click="confirmDialog = false"
        ) Cancelar
        v-btn(
          color="error"
          @click="deleteTemplate"
        ) Eliminar
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'CustomizationTemplatesView',
  
  data: () => ({
    dialog: false,
    selectGroupDialog: false,
    confirmDialog: false,
    valid: false,
    isEditing: false,
    expandedPanels: [],
    headers: [
      { text: 'Nombre', value: 'name', sortable: true },
      { text: 'Descripción', value: 'description', sortable: false },
      { text: 'Grupos de Selección', value: 'selectionGroups.length', sortable: true },
      { text: 'Estado', value: 'active', sortable: true },
      { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
    ],
    editedItem: {
      name: '',
      description: '',
      active: true,
      selectionGroups: []
    },
    defaultItem: {
      name: '',
      description: '',
      active: true,
      selectionGroups: []
    },
    selectedGroup: null,
    newGroupItem: {
      required: false,
      maxSelections: 0,
      minSelections: 0
    },
    itemToDelete: {},
    rules: {
      required: v => !!v || 'Este campo es requerido'
    }
  }),
  
  computed: {
    ...mapState({
      templates: state => state.customizationTemplates.templates,
      loading: state => state.customizationTemplates.loading,
      selectionGroups: state => state.selectionGroups.list
    }),
    
    availableGroups() {
      if (!this.editedItem.selectionGroups) return this.selectionGroups;
      
      // Filtrar grupos que ya están en la plantilla
      const existingGroupIds = this.editedItem.selectionGroups.map(item => item.group._id || item.group);
      return this.selectionGroups.filter(group => !existingGroupIds.includes(group._id));
    }
  },
  
  created() {
    this.fetchTemplates();
    this.fetchSelectionGroups();
  },
  
  methods: {
    ...mapActions({
      fetchTemplates: 'customizationTemplates/fetchTemplates',
      saveTemplate: 'customizationTemplates/createTemplate',
      updateTemplate: 'customizationTemplates/updateTemplate',
      removeTemplate: 'customizationTemplates/deleteTemplate',
      fetchSelectionGroups: 'selectionGroups/fetch'
    }),
    
    openDialog(item) {
      this.isEditing = !!item._id;
      this.editedItem = this.isEditing 
        ? { ...item } 
        : { ...this.defaultItem };
      
      // Asegurarse de que selectionGroups es un array
      if (!this.editedItem.selectionGroups) {
        this.editedItem.selectionGroups = [];
      }
      
      this.dialog = true;
      this.$nextTick(() => {
        this.$refs.form.resetValidation();
      });
    },
    
    closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
      });
    },
    
    getGroupName(group) {
      if (!group) return 'Grupo no encontrado';
      return typeof group === 'object' ? group.name : 'Cargando...';
    },
    
    addSelectedGroup() {
      if (!this.selectedGroup) return;
      
      // Crear una copia del objeto de grupo
      const groupItem = {
        group: this.selectedGroup._id,
        required: this.newGroupItem.required,
        maxSelections: this.newGroupItem.maxSelections || 0,
        minSelections: this.newGroupItem.minSelections || 0
      };
      
      // Asegurar que selectionGroups es un array
      if (!this.editedItem.selectionGroups) {
        this.editedItem.selectionGroups = [];
      }
      
      // Agregar el grupo a la lista
      this.editedItem.selectionGroups.push(groupItem);
      
      // Expandir el panel
      this.$nextTick(() => {
        const index = this.editedItem.selectionGroups.length - 1;
        if (!this.expandedPanels.includes(index)) {
          this.expandedPanels.push(index);
        }
      });
      
      // Restablecer valores
      this.selectedGroup = null;
      this.newGroupItem = {
        required: false,
        maxSelections: 0,
        minSelections: 0
      };
      
      this.selectGroupDialog = false;
    },
    
    removeGroup(index) {
      this.editedItem.selectionGroups.splice(index, 1);
      
      // Actualizar los índices expandidos
      this.expandedPanels = this.expandedPanels
        .map(i => (i >= index ? i - 1 : i))
        .filter(i => i >= 0 && i < this.editedItem.selectionGroups.length);
    },
    
    async save() {
      if (!this.$refs.form.validate()) return;
      
      try {
        // Preparar objeto para guardar
        const templateData = { ...this.editedItem };
        
        // Transformar los grupos de selección para la API
        if (templateData.selectionGroups) {
          templateData.selectionGroups = templateData.selectionGroups.map(item => {
            return {
              group: typeof item.group === 'object' ? item.group._id : item.group,
              required: item.required,
              maxSelections: item.maxSelections || 0,
              minSelections: item.minSelections || 0
            };
          });
        }
        
        if (this.isEditing) {
          await this.updateTemplate({
            id: templateData._id,
            template: templateData
          });
        } else {
          await this.saveTemplate(templateData);
        }
        
        this.closeDialog();
        this.$store.dispatch('setLoading', false);
        this.$store.dispatch('setError', null);
        
        this.$toast.success(
          this.isEditing
            ? '¡Plantilla actualizada exitosamente!'
            : '¡Plantilla creada exitosamente!'
        );
      } catch (error) {
        this.$store.dispatch('setError', error.message);
        this.$toast.error('Error al guardar la plantilla');
      }
    },
    
    confirmDelete(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    
    async deleteTemplate() {
      try {
        await this.removeTemplate(this.itemToDelete._id);
        this.confirmDialog = false;
        this.$toast.success('Plantilla eliminada exitosamente');
      } catch (error) {
        this.$store.dispatch('setError', error.message);
        this.$toast.error('Error al eliminar la plantilla');
      }
    }
  }
};
</script>
